import { useCallback, useState } from "react";

import { USER_UID } from "../constants";

export default function useUserUid() {
  const [userUid, _setUserUid] = useState<string | undefined>(
    window.localStorage.getItem(USER_UID) ? window.localStorage.getItem(USER_UID) || "" : undefined
  );

  const setUserUid = useCallback((userUid?: string) => {
    if (userUid) window.localStorage.setItem(USER_UID, userUid);
    _setUserUid(userUid);
  }, []);

  return [userUid, setUserUid] as const;
}
